import workspaceQuery from '../../queries/product/GoodsReceiptWorkspaceQuery.graphql';
import listQuery from '../../queries/product/GoodsReceiptListQuery.graphql';
import instanceQuery from '../../queries/product/GoodsReceiptQuery.graphql';
import defaultQuery from '../../queries/product/GoodsReceiptDefault.graphql';
import mutationQuery from '../../mutations/product/GoodsReceiptMutation.graphql';
import temporaryMutationQuery from '../../mutations/product/GoodsReceiptTempMutation.graphql';
import fragment from '../../fragments/product/GoodsReceiptFragment.graphql';
import { ALLOW_ADD, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { document } from '../../../utils/mailMergeFields';
import { goodsReceiptFormActionsForPermissions } from '../../../actions/product/GoodsReceiptAction';
import { EntityType } from '../../../@types/entityTypes';

const GoodsReceipt: EntityType = {
  type: 'GoodsReceipt',
  title: 'Goods Receipts',
  formTitle: 'Goods Receipt',
  formUrl: '/Products/StockControl/GoodsReceipt/Details/',
  workspaceUrl: '/Products/StockControl/GoodsReceipt/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
    remoteFilter: true,
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_GOODS_RECEIPTS',
  operations: ALLOW_ADD | ALLOW_VIEW,
  mergeFields: document,
  actions: goodsReceiptFormActionsForPermissions,
};

export default GoodsReceipt;
